import React, { useEffect, useState } from "react";
import CompanyModal from "@/components/Onboarding/CompanyModal";
import { InviteMember } from "@/components/Onboarding/InviteMembers";
import PaymentModal from "@/components/Onboarding/PaymentModal";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { serverGET } from "@/utils/HttpFunctions";
import useUserStore from "@/utils/Stores/userStore";
import { useCookies } from "react-cookie";
import Loader from "../Global/Loader";
import Navbar from "../Global/Navbar";

export default function Onboarding() {
  const [step, setStep] = useState<"info" | "invite" | "payment">("info");
  const login = useUserStore((state: any) => state.login);
  const user = useUserStore((state: any) => state.user);
  const logout = useUserStore((state: any) => state.logout);
  const [cookie, setCookie] = useCookies(["inviteModal"]);
  // to persist form data
  const [formData, setFormData] = useState({
    companyInfo: {},
    inviteDetails: {},
  });
  const [searchParams] = useSearchParams();
  const session = searchParams.get("session_id");
  const { data: tenantUserData, isLoading } = useQuery({
    queryKey: ["userInfo", user?._id], // Unique query key
    queryFn: () => serverGET(`/auth/tenant/` + user?._id), // Query function
    enabled: !!session, // Only run the query if id is truthy
  });
  useEffect(() => {
    if (tenantUserData) {
      const { tokens, user } = tenantUserData;

      setCookie("inviteModal", true, {
        path: "/",
        maxAge: 300,
      });
      login(user);
      // Store tokens in localStorage
      localStorage.setItem("accessToken", tokens.accessToken?.token);
      localStorage.setItem("refreshToken", tokens.refreshToken?.token);
    }
  }, [tenantUserData]);

  const updateFormData = (key: string, data: any) => {
    setFormData((prev) => ({
      ...prev,
      [key]: data,
    }));
  };

  if (isLoading && session) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      {step === "info" && (
        <CompanyModal
          data={formData.companyInfo}
          handleContinue={(data) => {
            updateFormData("companyInfo", data);
            setStep("payment");
          }}
          handleLogout={logout}
        />
      )}
      {/* {step === "invite" && (
        <InviteMember
          data={formData.inviteDetails}
          handleContinue={(data) => {
            updateFormData("inviteDetails", data);
            setStep("payment");
          }}
          handleBack={() => setStep("info")}
          teamPage={false}
        />
      )} */}

      {step === "payment" && (
        <PaymentModal
          handleBack={() => setStep("info")}
          handleLogout={logout}
        />
      )}
    </div>
  );
}
